import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import TimeIntervalStep from "../../../../../../../shared/wizard/steps/timeIntervalStep";
import { EDealRequestTimeInterval } from "../../../../../../../shared/wizard/steps/types";

interface IWishSwapStepBuy_6 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishSwapStepBuy_6 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IWishSwapStepBuy_6) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_5);
    onReset(["timeIntervalTypeView"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_7);
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="view"
        text="Желаемое время просмотра:"
      />
    </div>
  );
};

export default WishSwapStepBuy_6;
